// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-5e269ccb"};